import getCsrfToken from '../../lib/csrfToken';
import { checkTotalSizeUrl } from '../../modules/Viewer/urls';

async function checkTotalSize(ids: number[]) {
  const urlPath = checkTotalSizeUrl(ids);  
  const path = '/' + urlPath;

  const formData = new FormData();
  formData.append('ids', ids.join(','));

  const headers: HeadersInit = new Headers();
  const token = getCsrfToken();
  if (token !== undefined) {
    headers.set('X-CSRFToken', token);
  }

  const resp = await fetch(path, {
    method: 'POST',
    headers: headers,
    body: formData
  });

  const json = await resp.json();
  return json;
}

export default checkTotalSize;